import { setCurrentView } from 'core/utils';
import React from 'react';
import { observer } from 'mobx-react';
import { LinksTemplate } from 'themes/modules/links/pages';
import { LinksViewStore } from '../stores';

@setCurrentView(rootStore => new LinksViewStore(rootStore), 'linksViewStore')
@observer
class Links extends React.Component {
	render() {
		return <LinksTemplate {...this.props} viewStore={this.props.linksViewStore} />;
	}
}

export default Links;
